module.exports = __webpack_public_path__ + "static/taco-52de02ee89cf68cd61cb3bd21225c1f7.gif";